module.exports = {
      id: "glyph:arrow-up--hover-usage",
      viewBox: "0 0 16 16",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#glyph:arrow-up--hover-usage",
      toString: function () {
        return this.url;
      }
    }